// @ts-nocheck
import { create } from 'zustand';

const useUIStore = create((set, get) => ({
  width: typeof window !== 'undefined' ? window.innerWidth : 1200,
  mobile: () => get().width < 768,
  onWindowResize: (_e, { width }) => set({ width }),
  reset: () => set({
    width: typeof window !== 'undefined' ? window.innerWidth : 1200,
  }),
}));

export const selectMobile = (s) => s.width < 768;

export default useUIStore;
